import React from 'react';
import { MapPin } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const AREAS = ['Tulsa', 'Broken Arrow', 'Jenks', 'Owasso', 'Bixby', 'Sand Springs', 'Sapulpa', 'Glenpool', 'Catoosa', 'Claremore', 'Coweta', 'Skiatook'];
export function ServiceAreas() {
  return <section id="areas" className="bg-slate-50 py-20 sm:py-24" data-id="element-182" data-mp="23xeng1bzj2h4">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-183" data-mp="23zr50ddtzatn">
        <SectionHeading eyebrow="Service Areas" title="Proudly serving Green Country" subtitle="Locally owned and operated — we bring premium water treatment to homes across the greater Tulsa metro." data-id="element-184" data-mp="1q5rgn7kf2bk3" />
        <div className="mx-auto mt-12 flex max-w-3xl flex-wrap justify-center gap-3" data-id="element-185" data-mp="1g6ipsnkuld1y">
          {AREAS.map(a => <span key={a} className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-navy-900 shadow-sm" data-id="element-186" data-mp="177xb53ihyi6g">
              <MapPin className="h-4 w-4 text-brand-blue" data-id="element-187" data-mp="2di0evh3jc6pn" />
              {a}
            </span>)}
        </div>
      </div>
    </section>;
}